/**
 * For browsers that don't choke on webpack, but can't run the UI (IE9/10 mainly due to lack of websocket support),
 * we show an overlay image over the screen since the embed script isn't compatible with old browsers, which would
 * insert the iframe into the page. It can be dismissed with "Continue anyway" to continue by using text mode.
 */

export default function browsercheck() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // require('@imprivata/nucleus/build/nucleus.css');
    const div = document.createElement('div');
    document.body.appendChild(div);
    const thisScript = document.querySelector('script[data-access-token]');
    const parser = document.createElement('a');
    parser.href = thisScript.src;
    const host = parser.host;

    const alertImageUrl = '//' + host + require('../images/alert.png');
    const logoImageUrl = require('../images/imprivata_logo.png');


    div.style.cssText = 'position: absolute; top: 0; right: 0; bottom: 0; left: 0; z-index: 20';
    div.innerHTML = `
      <div class="login-container" style="margin: 0 auto; background-color: white; height: 100%; width: 100%; text-align: center">
        <div class="form-group login-header" style="padding-top: 64px">
          <img src=` + alertImageUrl + `
            id="AuthError_header_image"
            class="header-image"
            alt="Authentication Error"
          />
          <h2 id="AuthError_header_title"
            class="header-title" style="font-size: 20px"
          >
            Browser not supported
          </h2>
          <p id="AuthError_header_description"
            class="header-description" style="font-size: 16px"
          >
            Try using the latest version of Chrome, Edge, Firefox, Internet Explorer, or Safari.
          </p>
          <p class="header-description" style="font-size: 16px">
            Contact your help desk for additional assistance.
          </p>
        </div>
        <div class="form-group text-center" style="font-size: 16px">
          <a href="javascript:void(0)" onClick="
            var self = document.querySelector('.login-container');
            self.parentNode.removeChild(self);"
            >
          Continue anyway
          </a>
        </div>
        <div class="logo" style="margin-top: 32px;">
          <img src=` + logoImageUrl + ` 
            alt="Imprivata Logo"/>
        </div>
      </div>
      `;
    return false;
  }
  return true;
}
